import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { UserStoreService } from '../user/user-store.service';
import Amplify, { Auth } from 'aws-amplify';
import { ICuc } from '../user/user-requests.service';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { defer } from 'rxjs';
import * as SecureLS from 'secure-ls';
import jwt_decode from "jwt-decode";
@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private storage: StorageService,
    private userStore: UserStoreService,
    private globalService: GlobalService,
    private http: HttpClient,
  ) {}

  load() {
    return new Promise((resolve) => {
      const headers = new HttpHeaders({'Authorization': 'Basic ' + btoa('web-fondos:WK4Vuh4KPwCTL3Gc3LP19WSaZDHix38x63Bkv4KAWp8')});
      this.http.get(environment.baseHref + 'assets/configs/config.json', { headers }).subscribe((configResponse: any) => {
        this.globalService.globalEnvironments = configResponse;
        var ls = new SecureLS({encodingType: 'aes'});
        var current_time = new Date().getTime() / 1000;
        var exp = ls.get('exp')?ls.get('exp'):0; 
        if (current_time > exp) {
          ls.removeAll();
          //this.storage.reset();
          resolve(false);
        }
        var tab = this.getTabId()
        console.log('tre?'+tab);
        if(!tab){
          localStorage.clear();
          //this.storage.reset();
          resolve(false);
        }

        Amplify.configure({ Auth: this.globalService.globalEnvironments.AmplifyAuth });
        Auth.currentSession()
          .then((data: any) => {
            this.storage.getSession.subscribe(
              (activeSession: any) => {
                if (activeSession && activeSession.idToken) {this.userStore.authToken = activeSession.idToken.jwtToken;
                  var jwt: any = jwt_decode(this.userStore.authToken);
                  var ls = new SecureLS({encodingType: 'aes'});
                  ls.set('exp', jwt.exp); 
                  this.storage.listCUCS.subscribe((listCUCS: ICuc[]) => {
                    this.userStore.userCUC = listCUCS;
                    this.storage.activeCUC.subscribe((activeCUC: ICuc) => {
                      this.userStore.activeCUC = activeCUC;
                      this.storage.userData.subscribe((userData: any) => {
                        this.userStore.COGNITO_USER_DATA = userData;
                        this.storage.getLastSession.subscribe((sessionData: any) => {
                          this.userStore.lasActive = sessionData;
                          Auth.currentAuthenticatedUser().then((cognitoUser: any) => {this.userStore.COGNITO_USER = cognitoUser;})
                        });
                      });
                    });
                  });
                } else {
                  defer(() => Auth.signOut()).subscribe(() => {
                    this.userStore.COGNITO_TOKEN = '';this.userStore.COGNITO_CODE = '';this.userStore.COGNITO_USER = '';this.userStore.activeCUC = null;this.userStore.authToken = null;
                  });
                }
                resolve(true);
              },
              () => {
                resolve(true);
              }
            );
          })
          .catch(() => {
            this.storage.reset();
            resolve(true);
          });
      });
    });
  }

  getTabId() {
    var ls = new SecureLS({encodingType: 'aes'});
    var tab = ls.get('tab')?ls.get('tab'):0; 

    if(tab){
      if(tab != sessionStorage.tabID){
        return false;
      }
    }
    /*
    if(sessionStorage.tabID){
      if(tab != sessionStorage.tabID){
        return false;
      }
    }*/
    else{
      var array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      var tabID = sessionStorage.tabID = array[0];
      ls.set('tab', tabID); 
    }
/*
    if(localStorage.openTabs > 0){
      return false;
    }
*/
    return true;
  }

  startup() {}
}
